import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";

function Register() {
  const { formDataFunc } = useApiFunction();
  const { joinMemberToken } = useContext(valueContext);
  const token = joinMemberToken();
  const [isLoading, setIsLoading] = useState(false);
  const [loginInput, setLoginInput] = useState({
    email: "",
    password: "",
    username: "",
    name: "",
    twlUserName: "",
    mobileNo: "",
    confirmPassword: ""
  });
  const navigate = useNavigate();

  const handleChange = e => {
    setLoginInput({
      ...loginInput,
      [e.target.name]: e.target.value
    });
  };
  function togglePasswordVisibility(str) {
    var passwordInput = document.getElementById(`${str}`);

    if (passwordInput.type === "password") {
      passwordInput.type = "text";
    } else {
      passwordInput.type = "password";
    }
  }
  async function submitLogin(e) {
    e.preventDefault();
    setIsLoading(true);
    if (
      !loginInput.name ||
      !loginInput.mobileNo ||
      !loginInput.email ||
      !loginInput.password ||
      !loginInput.confirmPassword ||
      !loginInput.twlUserName
    ) {
      toast.warning("Please fill all the details", {
        autoClose: 2000
      });
      setIsLoading(false);
    } else {
      let body = JSON.stringify({
        name: loginInput.name,
        email: loginInput.email,
        mobile_number: loginInput.mobileNo,
        password: loginInput.password,
        confirm_password: loginInput.confirmPassword,
        twlUserName: loginInput.twlUserName
      });
      const res = await formDataFunc(`member/signUp`, body, "POST", token);
      if (res.status) {
        toast.success("Successfully Registerd", { autoClose: 2000 });
        setIsLoading(false);
        setLoginInput({
          email: "",
          password: "",
          name: "",
          mobileNo: "",
          confirmPassword: "",
          twlUserName: ""
        });
      } else if (
        res.error &&
        (res.error === "ERROR_TOKEN_INVALID0" ||
          res.error === "ERROR_TOKEN_INVALID1" ||
          res.error === "user not registered" ||
          res.error === "ERROR_TOKEN_INVALID2" ||
          res.error === "ERROR_TOKEN_INVALID3" ||
          res.error === "unauthorized" ||
          res.error === "Your session has expierd Please login again 1" ||
          res.error === "Your session has expierd Please login again 2")
      ) {
        navigate("/login");
      } else if (res.error) {
        setIsLoading(false);
        toast.warning(res.error, { autoClose: 2000 });
      } else {
        setIsLoading(false);
        toast.warning(res.msg, { autoClose: 2000 });
      }
    }
  }
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">New Registration</h4>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-7">
              <div className="card profile-section">
                <div className="card-body">
                  <div className="col-lg-12 col-md-12 col-sm-6">
                    <form
                      className="form-horizontal"
                      action="index.html"
                      onSubmit={submitLogin}
                    >
                      <div className="mb-3">
                        <label
                          for="username"
                          className="form-label sub-heading"
                        >
                          Name
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          placeholder="Enter name"
                          value={loginInput.name}
                          onChange={e => handleChange(e)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          for="username"
                          className="form-label sub-heading"
                        >
                          Tallwin userName
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="twlUserName"
                          placeholder="Enter Tallwin user name..."
                          value={loginInput.twlUserName}
                          onChange={e => handleChange(e)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          for="username"
                          className="form-label sub-heading"
                        >
                          Email
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          name="email"
                          placeholder="Enter email"
                          value={loginInput.email}
                          onChange={e => handleChange(e)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label
                          for="username"
                          className="form-label sub-heading"
                        >
                          Mobile Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="mobileNo"
                          placeholder="Enter MobileNo"
                          value={loginInput.mobileNo}
                          onChange={e => handleChange(e)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label sub-heading">
                          Password
                        </label>
                        <div className="input-group auth-pass-inputgroup">
                          <input
                            className="form-control"
                            type="password"
                            name="password"
                            id="passwordInput"
                            placeholder="Enter Password"
                            value={loginInput.password}
                            onChange={e => handleChange(e)}
                            required
                          />
                          <span
                            className="btn btn-light"
                            onClick={() =>
                              togglePasswordVisibility("passwordInput")
                            }
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </span>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label sub-heading">
                          Confirm Password
                        </label>
                        <div className="input-group auth-pass-inputgroup">
                          <input
                            className="form-control"
                            type="password"
                            name="confirmPassword"
                            id="passwordInput"
                            placeholder="Enter Password"
                            value={loginInput.confirmPassword}
                            onChange={e => handleChange(e)}
                            required
                          />
                          <span
                            className="btn btn-light"
                            onClick={() =>
                              togglePasswordVisibility("passwordInput")
                            }
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </span>
                        </div>
                      </div>

                      <div className="mt-3">
                        <button type="submit" className="block-menu mt-4" disabled={isLoading}>
                          {isLoading && (
                            <i
                              className="bx bx-loader-circle rotating"
                              style={{ marginRight: "5px" }}
                            />
                          )}
                          Registeration
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    </div>
  );
}

export default Register;
